import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Create from './Create';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';

const Wizard = () => {

    const navigate = useNavigate();
    const {readData} = useEntityCrud('Business/GetAllBusinesses');
    const {addData} = useEntityCrud('Business/SetTerminal');
    const { readGetDataById: getPaymentTypes } = useEntityCrud('Info/getPaymentChannels');
    const [requestType, setRequestType] = useState('');
    const [terminalLocation, setTerminalLocation] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [businesses, setBusinesses] = useState([]);
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [selectedPaymentType, setSelectedPaymentType] = useState();
    const [businessId, setBusinessId] = useState();
    const [connectionType, setConnectionType] = useState();
    const [personnalData, setPersonnalData] = useState({});

    const handleBack = () => {
        navigate('/organizations', { replace: true });
    }

    useEffect(() => {
        getPaymentTypes().then(({ data }) => {
            if(data.status)
                setPaymentTypes(data.result);
        })
    },[])

    const findBusiness = () => {
        document.getElementById('btn-search').classList.add('btn-loading');
        const postedData = {
            person: {
                nationalCode,
            },
            postalCode
        }
        readData(postedData).then(({ data }) => {
            if(data.status && data.result.length){
                setBusinesses(data.result);
                if(requestType == 2 && terminalLocation == 2){
                    const business = data.result[0];
                    if(business){
                        setPersonnalData({
                            name: business.person.name,
                            lastName: business.person.lastName,
                            nationalCode: business.person.nationalCode,
                            cellphone: business.person.cellphone,
                            birthDate: business.person.birthDate
                        });
                    }
                }
            }else{
                toast.error('کسب و کاری یافت نشد');
            }
        }).catch(() => {
            toast.error('کسب و کاری یافت نشد');
        }).finally(() => {
            document.getElementById('btn-search').classList.remove('btn-loading');
        })
    }

    const requestTerminal = () => {
        const postedData = {
            businessId,
            connectionType: selectedPaymentType == 21 ? connectionType : 3
        }
        addData(postedData).then(({ data }) => {
            if(data.status){
                setRequestType('');
                setTerminalLocation('');
                setNationalCode('');
                setPostalCode('');
                setBusinesses([]);
                setPaymentTypes([]);
                setSelectedPaymentType();
                setBusinessId();
                setConnectionType();
                setPersonnalData({});
                toast.success('ثبت درخواست ترمینال با موفقیت انجام شد');
            }else
                toast.error('عملیات ناموفق بود');
        })
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد درخواست جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3 col-sm-12">
                        <div className="form-group">
                            <label>نوع درخواست</label>
                            <select className="form-control" onChange={e => setRequestType(e.target.value)}>
                                <option value="">انتخاب کنید</option>
                                <option value="1">ایجاد کسب و کار جدید</option>
                                <option value="2">دریافت پایانه برای کسب کار موجود در سیستم</option>
                            </select>
                        </div>
                    </div>
                    {requestType == 2 && <>
                        <div className="col-md-3 col-sm-12">
                            <div className="form-group">
                                <label>محل پایانه</label>
                                <select className="form-control" onChange={e => setTerminalLocation(e.target.value)}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="1">محل فعلی</option>
                                    <option value="2">محل جدید</option>
                                </select>
                            </div>
                        </div>
                        {terminalLocation && <div className="col-md-2 col-sm-12">
                            <div className="form-group">
                                <label>کد ملی مالک کسب و کار</label>
                                <input type="tel" className="form-control ltr-input" maxLength={10} onChange={e => setNationalCode(e.target.value)} />
                            </div>
                        </div>}
                        {terminalLocation == 1 && <div className="col-md-2 col-sm-12">
                            <div className="form-group">
                                <label>کد پستی محل فعلی</label>
                                <input type="tel" className="form-control ltr-input" maxLength={10} onChange={e => setPostalCode(e.target.value)} />
                            </div>
                        </div>}
                        {nationalCode && nationalCode.length == 10 && ((terminalLocation == 2) || (postalCode && postalCode.length == 10)) && <div className="col-md-2" style={{marginTop: 30}}>
                            <button className="btn btn-primary w-100" id="btn-search" onClick={findBusiness}>جستجو</button>
                        </div>}
                    </>}
                </div>
                {requestType == 1 && <>
                    <hr />
                    <div className="px-3 pt-3"><Create isEmbeded /></div>
                </>}
                {requestType == 2 && terminalLocation == 1 && businesses.length > 0 && <>
                    <hr />
                    <div className="px-3 pt-3">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>کسب و کار</label>
                                    <select className="form-control" onChange={e => setBusinessId(e.target.value)}>
                                        <option value="">انتخاب کنید</option>
                                        {businesses.map(business => <option value={business.id} key={`business-${business.id}`}>{business.title}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>
                        {businessId && <div className="row">
                            {paymentTypes.map(paymentType => <div className="col-md-2" key={paymentType.id}>
                                <div className="form-group mb-0 d-flex">
                                    <input
                                        type="radio"
                                        className="d-flex align-items-center ml-2 mt-0"
                                        name="paymentType"
                                        onChange={() => setSelectedPaymentType(paymentType.id)}
                                    />
                                    <label className="mt-2">{paymentType.title}</label>
                                </div>
                                {paymentType.id == 21 && selectedPaymentType == paymentType.id && <div>
                                    <div className="form-group mt-3 pe-5">
                                        <label>نوع ارتباط</label>
                                        <select className="form-control" onChange={e => setConnectionType(e.target.value)}>
                                            <option value="">انتخاب کنید</option>
                                            <option value="1">کابلی (LAN)</option>
                                            <option value="2">سیار (GPRS)</option>
                                        </select>
                                    </div>
                                </div>}
                            </div>)}
                        </div>}
                        {businessId && selectedPaymentType && ((selectedPaymentType == 21 && connectionType) || (selectedPaymentType && selectedPaymentType != 21 && true)) && <div className="row mt-4">
                            <div className="col-md-3">
                                <button className="btn btn-success" onClick={requestTerminal}>ثبت درخواست پایانه</button>
                            </div>
                        </div>}
                    </div>
                </>}
                {requestType == 2 && terminalLocation == 2 && businesses.length > 0 && <>
                    <hr />
                    <div className="px-3 pt-3"><Create isEmbeded personnalData={personnalData} /></div>
                </>}
            </div>
        </div>
    )
}

export default Wizard